
document.addEventListener('DOMContentLoaded', function () {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.items = [];
      this.categoryToggles = [];
      this.boundHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }

    init() {
      this.tabs = Array.from(this.querySelectorAll('.yg-collection-tab-item'));
      this.items = Array.from(this.querySelectorAll('.yg-right-box'));
      this.categoryToggles = Array.from(this.querySelectorAll('.yg-menu-category__toggle'));

      if (this.tabs.length === 0 || this.items.length === 0) return;

      this.switchTab(0);
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.items.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.classList.toggle('active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      const activeTab = this.tabs[index];
      const activeCategory = activeTab ? activeTab.closest('.yg-menu-category') : null;
      if (activeCategory) {
        this.expandCategory(activeCategory);
      }
    }

    expandCategory(category) {
      this.querySelectorAll('.yg-menu-category').forEach((item) => {
        const isExpanded = item === category;
        item.classList.toggle('is-expanded', isExpanded);

        const toggle = item.querySelector('.yg-menu-category__toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
      });
    }

    activateFirstTabInCategory(category) {
      const firstTab = category ? category.querySelector('.yg-collection-tab-item') : null;
      if (!firstTab) return;

      const index = this.tabs.indexOf(firstTab);
      if (index >= 0) {
        this.switchTab(index);
      }
    }

    clearHandlers() {
      this.boundHandlers.forEach(({ element, type, handler }) => {
        element.removeEventListener(type, handler);
      });
      this.boundHandlers = [];
    }

    addManagedListener(element, type, handler) {
      element.addEventListener(type, handler);
      this.boundHandlers.push({ element, type, handler });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;
      this.clearHandlers();

      this.tabs.forEach((tab, index) => {
        if (isMobile) {
          this.addManagedListener(tab, 'click', (event) => {
            event.preventDefault();
            this.switchTab(index);
          });
        } else {
          this.addManagedListener(tab, 'mouseenter', () => this.switchTab(index));
        }
      });

      this.categoryToggles.forEach((toggle) => {
        const category = toggle.closest('.yg-menu-category');
        this.addManagedListener(toggle, 'click', (event) => {
          event.preventDefault();
          this.activateFirstTabInCategory(category);
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.clearHandlers();
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  // Custom element: <yg-product-data-list> scrolls horizontally on hover.
  class YGProductDataList extends HTMLElement {
    constructor() {
      super();
      this._onEnter = this._onEnter.bind(this);
      this._onLeave = this._onLeave.bind(this);
    }

    connectedCallback() {
      // 延迟绑定以确保样式和尺寸已计算
      if (this._ygInit) return;
      this._ygInit = true;
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);
      // always ensure mask exists so it's visible even before hover
      this._ensureMask();

      document.addEventListener('click', function (e) {
        if (e.target.closest('.yg-colse-menu')) {
          const parent = e.target.closest('[is="mega-menu-disclosure"]');
          if (parent && parent.hasAttribute('open')) {
            parent.removeAttribute('open');
          }
          const mega_menu  = e.target.closest('.mega-menu ');
          if (mega_menu) {
            mega_menu.style.removeProperty('opacity');
          }
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
      // remove scroll listener
      if (this._hasScrollListener && this._onScroll) {
        this.removeEventListener('scroll', this._onScroll);
        this._hasScrollListener = false;
        this._onScroll = null;
      }
      // disconnect ResizeObserver
      if (this._ro) {
        try { this._ro.disconnect(); } catch (e) {}
        this._ro = null;
      }
      // cancel any running animation
      if (this._ygScrollRaf) {
        cancelAnimationFrame(this._ygScrollRaf);
        this._ygScrollRaf = null;
      }
      // remove mask if appended inside the list or inside a list-box container
      if (this._maskEl) {
        const possibleContainer = this.closest('.yg-product-data-list-box') || this;
        if (this._maskEl.parentElement === possibleContainer) {
          try { possibleContainer.removeChild(this._maskEl); } catch (e) {}
        }
      }
      this._maskEl = null;
      this._ygInit = false;
    }

    _onEnter() {
      // 仅在内容溢出时滚动并显示遮罩逻辑
      if (this.scrollWidth <= this.clientWidth) return;
      this._ensureMask();
      this._animateScrollTo(this.scrollWidth - this.clientWidth, 700);
    }

    _onLeave() {
      this._animateScrollTo(0, 700);
    }
    
    // 动画滚动到指定位置（ms），使用 easeInOutQuad
    _animateScrollTo(targetLeft, duration = 700) {
      const startLeft = this.scrollLeft;
      const change = targetLeft - startLeft;
      const startTime = performance.now();

      const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(1, elapsed / duration);
        const eased = easeInOutQuad(t);
        this.scrollLeft = Math.round(startLeft + change * eased);
        this._updateMaskVisibility();
        if (t < 1) {
          this._ygScrollRaf = requestAnimationFrame(step);
        } else {
          this._ygScrollRaf = null;
          this._updateMaskVisibility(true);
        }
      };

      if (this._ygScrollRaf) cancelAnimationFrame(this._ygScrollRaf);
      this._ygScrollRaf = requestAnimationFrame(step);
    }

    _ensureMask() {
      // attach mask INSIDE the nearest .yg-product-data-list-box if exists, otherwise inside this list element
      const container = this.closest('.yg-product-data-list-box') || this;
      // ensure container is positioned to allow absolute mask
      if (getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
      }

      if (!this._maskEl) {
        const mask = document.createElement('div');
        mask.className = 'yg-product-data__mask';
        mask.style.position = 'absolute';
        mask.style.right = '0';
        mask.style.width = '48px';
        mask.style.pointerEvents = 'none';
        mask.style.transition = 'opacity .25s ease';
        mask.style.background = 'linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)';
        container.appendChild(mask);
        this._maskEl = mask;

        // ResizeObserver to keep mask position/height in sync (observe this and container if available)
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(() => this._updateMaskPosition());
          this._ro.observe(this);
          if (container !== this) this._ro.observe(container);
        }
      }

      // attach scroll listener to update mask visibility when user scrolls manually
      if (!this._hasScrollListener) {
        this._onScroll = () => this._updateMaskVisibility();
        this.addEventListener('scroll', this._onScroll, { passive: true });
        this._hasScrollListener = true;
      }

      this._updateMaskPosition();
      this._updateMaskVisibility();
    }

    _updateMaskVisibility(forceHide = false) {
      if (!this._maskEl) return;
      const atRight = (this.scrollWidth - this.clientWidth - this.scrollLeft) <= 1;
      if ( atRight) {
        this._maskEl.style.opacity = '0';
      } else {
        this._maskEl.style.opacity = '1';
      }
    }

    _updateMaskPosition() {
      if (!this._maskEl) return;
      const container = this._maskEl.parentElement;
      // compute top relative to container
      const containerRect = container.getBoundingClientRect();
      const listRect = this.getBoundingClientRect();
      const top = listRect.top - containerRect.top;
      // set top and height to cover the list area
      this._maskEl.style.top = `${Math.max(0, Math.round(top))}px`;
      this._maskEl.style.height = `${Math.round(this.offsetHeight)}px`;
    }
  }

  if (!window.customElements.get('yg-product-data-list')) {
    window.customElements.define('yg-product-data-list', YGProductDataList);
  }

  class YGPriceButton extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      // 找到最近的 product-card 元素或包含 .product-card 的父节点
      const productCard = this.closest('product-card') || this.closest('.product-card');
      if (!productCard) return;

      const quickBuy = productCard.querySelector('.product-card__quick-buy');
      if (!quickBuy) return;

      // 优先触发显式的提交或按钮元素
      const trigger = quickBuy.querySelector('button[type="submit"], button, a, input[type="submit"]');
      if (trigger) {
        trigger.click();
      }
    }
  }

  if (!window.customElements.get('yg-price-button')) {
    window.customElements.define('yg-price-button', YGPriceButton);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      if (this.classList.contains("yg-accordion--disabled")) return;
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      if (!content) return;
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => {
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class MobileNavigationMenu extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
      this.handlePanelClick = this.handlePanelClick.bind(this);
      this.reset = this.reset.bind(this);
    }

    connectedCallback() {
      this.addEventListener('toggle', this.handleToggle, true);
      this.drawer = this.closest('navigation-drawer');
      this.panelList = this.closest('.panel-list__wrapper');
      this.panelList?.addEventListener('click', this.handlePanelClick);
      this.drawer?.addEventListener('dialog:after-hide', this.reset);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
      this.panelList?.removeEventListener('click', this.handlePanelClick);
      this.drawer?.removeEventListener('dialog:after-hide', this.reset);
    }

    handleToggle(event) {
      const target = event.target;

      if (!(target instanceof HTMLDetailsElement) || !target.open) return;

      const list = target.parentElement?.parentElement;
      if (!list || !list.classList.contains('mobile-navigation__list')) return;

      Array.from(list.children).forEach((item) => {
        const sibling = item.querySelector(':scope > details.mobile-navigation__details');

        if (sibling && sibling !== target && sibling.open) {
          sibling.open = false;
        }
      });
    }

    handlePanelClick(event) {
      const openButton = event.target.closest('[data-mobile-product-panel-open]');
      const backButton = event.target.closest('[data-mobile-product-panel-back]');

      if (!openButton && !backButton) return;

      event.preventDefault();

      const mainPanel = this.panelList?.querySelector(':scope > .mobile-navigation-main-panel');

      if (!mainPanel) return;

      if (openButton) {
        const panelId = openButton.getAttribute('data-mobile-product-panel-open');
        const productPanel = this.panelList.querySelector(
          `:scope > .mobile-navigation-product-panel[data-mobile-product-panel="${CSS.escape(panelId)}"]`
        );

        if (!productPanel) return;

        // navigation-drawer resets every non-root .panel by hiding its wrapper.
        // Product panels are opened independently, so restore their content before
        // making the selected panel visible again.
        productPanel.querySelectorAll('[hidden]').forEach((element) => {
          element.removeAttribute('hidden');
        });
        productPanel.style.removeProperty('opacity');
        productPanel.style.removeProperty('visibility');
        productPanel.style.removeProperty('transform');
        this.lastProductPanelButton = openButton;
        this.drawer?.classList.add('is-mobile-product-panel-open');
        mainPanel.classList.add('is-mobile-product-panel-open');
        mainPanel.setAttribute('aria-hidden', 'true');
        productPanel.classList.add('is-active');
        productPanel.setAttribute('aria-hidden', 'false');
        productPanel.querySelector('.mobile-navigation-product-panel__back')?.focus();
      } else {
        this.closeProductPanels();
        mainPanel.removeAttribute('aria-hidden');
        this.lastProductPanelButton?.focus();
      }
    }

    closeProductPanels() {
      this.panelList?.querySelectorAll(':scope > .mobile-navigation-product-panel.is-active').forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      this.panelList?.querySelector(':scope > .mobile-navigation-main-panel')?.classList.remove('is-mobile-product-panel-open');
      this.drawer?.classList.remove('is-mobile-product-panel-open');
    }

    reset() {
      this.closeProductPanels();
      this.panelList?.querySelector(':scope > .mobile-navigation-main-panel')?.removeAttribute('aria-hidden');
      this.querySelectorAll('details.mobile-navigation__details[open]').forEach((details) => {
        details.open = false;
      });
    }
  }

  if (!window.customElements.get('mobile-navigation-menu')) {
    window.customElements.define('mobile-navigation-menu', MobileNavigationMenu);
  }

  class YGBuyButtonPrice extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
      this.resizeTimer = null;
    }

    connectedCallback() {
      this.updateVisibility();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
    }

    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        this.updateVisibility();
      }, 80);
    }

    updateVisibility() {
      const priceList = this.querySelector('.price-list');
      if (!priceList) return;

      this.style.display = '';
      priceList.style.display = '';

      requestAnimationFrame(() => {
        const hasVisibleContent = priceList.offsetWidth > 0 || priceList.offsetHeight > 0;

        if (!hasVisibleContent) {
          this.style.display = '';
          priceList.style.display = '';
        }
      });
    }
  }

  if (!window.customElements.get('yg-buy-button-price')) {
    window.customElements.define('yg-buy-button-price', YGBuyButtonPrice)
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  function initYGProductGalleryPageCounter() {
    const galleries = document.querySelectorAll('.yg-product-gallery');

    galleries.forEach((gallery) => {
      const counter = gallery.querySelector('.yg-product-gallery__page-counter');
      const current = counter?.querySelector('.yg-product-gallery__page-current');
      const total = counter?.querySelector('.yg-product-gallery__page-total');
      const carousel = gallery.querySelector('.product-gallery__media-list');

      if (!counter || !current || !total || !carousel) return;

      let currentSlide = null;

      const getSlides = () => Array.from(carousel.querySelectorAll('.product-gallery__media'));
      const getVisibleSlides = () => {
        return getSlides().filter((item) => {
          return !item.hasAttribute('hidden') && item.classList.contains('active');
        });
      };

      const updateCounter = () => {
        const visibleSlides = getVisibleSlides();

        if (visibleSlides.length <= 1) {
          counter.hidden = true;
          return;
        }

        counter.hidden = false;
        total.textContent = String(visibleSlides.length);

        if (!currentSlide || !visibleSlides.includes(currentSlide)) {
          currentSlide = visibleSlides[0];
        }

        current.textContent = String(visibleSlides.indexOf(currentSlide) + 1);
      };

      currentSlide = getVisibleSlides()[0] || null;
      updateCounter();

      carousel.addEventListener('carousel:change', (event) => {
        const slides = getSlides();
        currentSlide = slides[event.detail.index] || currentSlide;
        updateCounter();
      });

      const observer = new MutationObserver(() => updateCounter());
      observer.observe(carousel, {
        subtree: true,
        childList: false,
        attributes: true,
        attributeFilter: ['hidden', 'class', 'aria-current']
      });
    });
  }

  initYGProductGalleryPageCounter();
})
